import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { achievementsEndpoints } from '../../../../constants';
import { AchievementsResponse } from '../../../user/schemas/achievement.schema';

class AchievementsApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getAchievements = async (): Promise<AchievementsResponse> => {
    return this.#requestInstance.get(achievementsEndpoints.achievementsAvailable);
  };
}

export const achievementsApi = new AchievementsApi(axios);
